<template>
  <full-page title="Open Tables">
    <AllTables/>
  </full-page>
</template>

<script>
import AllTables from "@/components/point-of-sale/table/AllTables";
import FullPage from "@/components/layout/utils/FullPage";

export default {
  name: "AllTablesView",
  components: {FullPage, AllTables},
  beforeRouteLeave(to, from, next){
    this.$store.commit("setOpenTableName", null)
    return next();
  }
}
</script>